import { render } from "./RoomBookingView.vue?vue&type=template&id=56e61591"
import script from "./RoomBookingView.vue?vue&type=script&lang=js"
export * from "./RoomBookingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__